/**
 * Test IDs for QA automation.
 */
export const testIds = {
  billingRuleFormRemoveCondition: "billing-rule-form-remove-condition",
  billingRuleFormAddCondition: "billing-rule-form-add-condition",
  billingRuleFormRemoveRate: "billing-rule-form-remove-rate",
  billingRuleFormAddRate: "billing-rule-form-add-rate",
  billingRuleFormActive: "billing-rule-form-active",
} as const;
